import dayjs from 'dayjs';
import { CSSProperties } from 'react';
import { EventPropGetter } from 'react-big-calendar';
import { RobotCalendarEvent } from '../components/RobotSchedule/RobotSchedule.types';

// Toggled on <body> during a resize drag so the ns-resize cursor stays locked for the whole drag.
export const RESIZE_LOCKED_CURSOR_CLASS = 'robot-schedule__resize-locked-cursor';

export const HOURS_IN_DAY = 24;
// Used until the time grid has been measured (see the effect in RobotSchedule.tsx).
export const FALLBACK_VIEWPORT_HOURS = 8;

// Time-of-day RBC should pin to the top of the grid so that "now" ends up vertically centred in the
// `viewportHours`-tall visible window. Clamped to [0, 24 - viewportHours] so the window never runs
// past midnight on either end — near the day's edges "now" stays visible (just no longer centred).
export const getCenteredScrollToTime = (viewportHours: number): Date => {
  const now = dayjs();
  const nowHours = now.hour() + now.minute() / 60;
  const maxTopHours = Math.max(0, HOURS_IN_DAY - viewportHours);
  const topHours = Math.min(Math.max(nowHours - viewportHours / 2, 0), maxTopHours);

  return now
    .startOf('day')
    .add(Math.round(topHours * 60), 'minute')
    .toDate();
};

// Moves RBC's bottom resize handle from the box's true bottom up to the cleaning/charging seam,
// via a CSS custom property read in RobotSchedule.styles.tsx.
export const getEventProps: EventPropGetter<RobotCalendarEvent> = event => {
  const { chargingDurationMs, startAt, endAt } = event.resource.scheduleEvent;
  const cleaningMs = dayjs(endAt).diff(dayjs(startAt));
  const totalMs = cleaningMs + chargingDurationMs;
  // Clamp against bad data (endAt before startAt) so the handle position stays within the box
  const chargingFraction = chargingDurationMs > 0 && totalMs > 0 ? Math.min(chargingDurationMs / totalMs, 1) : 0;
  const style: CSSProperties & { '--robot-schedule-charging-fraction': number } = {
    '--robot-schedule-charging-fraction': chargingFraction,
  };

  return { style };
};
